import { loadView } from '@/router'

export default [
  {
    path: 'opportunities',
    name: 'sales-opportunities',
    component: loadView('Application/Sales/Opportunities'),
    redirect: {
      name: 'sales-opportunities-list'
    },
    children: [
      {
        path: 'list',
        name: 'sales-opportunities-list',
        component: loadView('Application/Sales/Opportunities/List')
      },
      {
        path: ':accountId',
        name: 'sales-opportunities-account',
        component: loadView('Application/Sales/Opportunities/Account'),
        redirect: {
          name: 'sales-opportunities-account-todo'
        },
        children: [
          {
            path: 'contacts',
            name: 'sales-opportunities-account-contacts',
            component: loadView('Application/Sales/Opportunities/Account/Contacts')
          },
          {
            path: 'attachments',
            name: 'sales-opportunities-account-attachments',
            component: loadView('Application/Sales/Opportunities/Account/Attachments')
          },
          {
            path: 'configure',
            name: 'sales-opportunities-account-configure',
            component: loadView('Application/Sales/Opportunities/Account/Configure')
          },
          {
            path: 'notes',
            name: 'sales-opportunities-account-notes',
            component: loadView('Application/Sales/Opportunities/Account/Notes')
          },
          {
            path: 'todo',
            name: 'sales-opportunities-account-todo',
            component: loadView('Application/Sales/Opportunities/Account/ToDo')
          }
        ]
      }
    ]
  }
]
